export default __webpack_public_path__ + "static/media/cdk8s.63377408.svg";